/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LinkSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LinkSmall',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 14 * scale,
      viewBox: '0 0 14 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"m8.768 5.395-.163-.163a3 3 0 0 0-.442-.36l-.944.943a2 2 0 0 1 .463.336l.163.167c.374.375.58.877.58 1.414s-.206 1.04-.58 1.414l-1.613 1.612c-.375.375-.877.582-1.414.582s-1.04-.207-1.414-.582l-.164-.163a2 2 0 0 1-.398-2.245 2.38 2.38 0 0 1-.487-1.537l-.034.037a3.31 3.31 0 0 0 0 4.667l.163.164c.64.642 1.487.963 2.332.963s1.69-.32 2.33-.962l1.613-1.612a3.31 3.31 0 0 0 0-4.667z"}),createElement('path', {"fill":"currentColor","d":"M5.387 8.776c.137.137.288.253.442.36l.94-.943a2 2 0 0 1-.466-.336l-.164-.163a2 2 0 0 1-.58-1.414c0-.538.208-1.04.583-1.415l1.612-1.612c.376-.375.878-.582 1.415-.582s1.04.21 1.414.586l.163.163a2 2 0 0 1 .42 2.2c.354.44.537.97.533 1.504a3.307 3.307 0 0 0-.034-4.624l-.163-.164c-.642-.642-1.488-.963-2.333-.963s-1.692.322-2.334.963l-1.612 1.61a3.31 3.31 0 0 0 0 4.668l.163.163z"}))
}
